import React from 'react';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';

import { PageState } from 'components';

interface SignFailureProps {
  errorMessage?: string;
  onReset: () => void;
}

export const SignFailure = ({ errorMessage, onReset }: SignFailureProps) => {
  const handleLeave = (e: React.MouseEvent) => {
    e.preventDefault();
    onReset();
  };

  return (
    <PageState
      className='px-4 py-0'
      icon={faCircleXmark}
      iconClass='warning'
      title='Message not signed'
      description={errorMessage}
      action={
        <button
          data-testid='closeTransactionSuccessBtn'
          id='closeButton'
          className='btn btn-primary mb-3'
          onClick={handleLeave}
        >
          Try again
        </button>
      }
    />
  );
};
